<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Вид договора</div>
            <div :class="fieldValueClass">
                <ai-select-box-clearable
                    v-model:value="value"
                    :data-source="dataSource"
                    :disabled="disabled"
                    :showClearButton="false"
                    display-expr="vid_name"
                    value-expr="kod_vdog"
                    @opened="onOpenHandler"
                    @valueChanged="valueChanged"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, inject, onBeforeMount, ref } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';
import { getVid } from '@/service/contract-service';

const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            getDictionary: null,
        }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});

const serverData = inject('serverData');
const userData = inject('userData');
const dataSource = ref(props.ds);

const onOpenHandler = async () => {
    await getDictionaryHandler();
};

onBeforeMount(async () => {
    const initialDS = [
        {
            [`kod_vdog`]: userData?.value[`kod_vdog`],
            [`vid_name`]: userData?.value[`vid_name`],
        },
    ];
    if (dataSource.value.length === 0 && serverData?.value.length !== 0 && initialDS) {
        dataSource.value = initialDS;
    }
});

const getDictionaryHandler = async () => {
    const response = await getVid(userData?.value[`podr`]);
    console.log('component-type getDictionaryHandler ', response);
    if (response) {
        dataSource.value = response;
    } else {
        console.log(response.error, response.uuid);
    }
};

const valueChanged = e => {
    userDataChange(e.value, e.text);
};

const userDataChange = (value, text) => {
    userData.value['kod_vdog'] = value;
    if (text) {
        userData.value['vid_name'] = text;
    }
    props.callbacks.userDataChanged();
};

const isModified = computed(() => {
    return userData?.value['kod_vdog'] !== serverData?.value['kod_vdog'];
});

const value = computed(() => {
    if (userData.value['kod_vdog'] === undefined) {
        return null;
    }
    return userData.value['kod_vdog'];
});

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
        'ai-field-modified': isModified.value,
    };
});
</script>
